var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 90,
    viewBox: "0 0 73.0 90.0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14,0L59,0C66.732,-0 73,6.268 73,14L73,76C73,83.732 66.732,90 59,90L14,90C6.268,90 0,83.732 0,76L0,14C0,6.268 6.268,-0 14,0Z",
    fill: "#619f09ff",
    strokeWidth: 1,
    stroke: "#00000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14,0L59,0C66.732,0 73,6.268 73,14L73,72C73,79.732 66.732,86 59,86L14,86C6.268,86 0,79.732 0,72L0,14C0,6.268 6.268,0 14,0Z",
    fill: "#7ac70cff",
    strokeWidth: 1,
    stroke: "#00000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank);
export default __webpack_public_path__ + "static/media/rank.2f8ac8f3947344d4864dddd70cff5169.svg";
export { ForwardRef as ReactComponent };